var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(-2808 -10425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(2259 10027)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 220,
    height: 220,
    rx: 5,
    transform: "translate(549 398)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(2881.717 10467.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(40.825 47.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M287.544,108.74a4,4,0,1,0,4,4A4,4,0,0,0,287.544,108.74Z",
    transform: "translate(-283.548 -108.74)",
    fill: "#d0dadf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(23.275 72.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M174.687,286.1a13.031,13.031,0,1,0,13.032,13.03A13.03,13.03,0,0,0,174.687,286.1Zm7.341,14.575h-5.664v5.809a1.7,1.7,0,0,1-3.4,0v-5.809h-5.64a1.7,1.7,0,0,1,0-3.4h5.64v-5.5a1.7,1.7,0,0,1,3.4,0v5.5h5.664a1.7,1.7,0,0,1,0,3.4Z",
    transform: "translate(-161.656 -286.1)",
    fill: "#d0dadf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 36.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M69.737,36.892H2.876A2.979,2.979,0,0,0,0,39.847V82.968a2.744,2.744,0,0,0,2.876,2.678h17a16.433,16.433,0,0,1,32.866,0h17a2.7,2.7,0,0,0,2.828-2.678V39.847A2.938,2.938,0,0,0,69.737,36.892ZM56.368,56.424,45.648,67.147,29.33,50.831a.566.566,0,0,0-.8,0L18.179,61.181l-4.725-4.724a.591.591,0,0,0-.822,0L5.1,63.966V41.994H67.463V66.722l-10.294-10.3A.565.565,0,0,0,56.368,56.424Z",
    transform: "translate(0 -36.892)",
    fill: "#d0dadf"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderStore);
export default __webpack_public_path__ + "static/media/placeholderStore.04272f59c560a7363b0fe2e647fea334.svg";
export { ForwardRef as ReactComponent };